// Redux slice for managing soft tags, filters, and pagination
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { getFirstFeature } from './firstFeature.thunk';


// State shape for tags feature
interface FirstFeatureState {
    loading: boolean;
    firstFeatureData?: any; // Replace with actual data type
    error?: string | null;
}

// Initial state for tags slice
const initialState: FirstFeatureState = {
    loading: false,
    firstFeatureData: undefined,
    error: null,
};

// Slice for tags feature with reducers and extraReducers for async actions
const firstFeatureSlice = createSlice({
  name: 'firstFeature',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      // Handle getSoftTags pending state
      .addCase(getFirstFeature.pending, state => {
        state.loading = true;
        state.error = null;
      })

      // Handle getFirstFeature fulfilled state
      .addCase(
        getFirstFeature.fulfilled,
        (state, action: PayloadAction<any>) => {
            state.firstFeatureData = action.payload;
            state.loading = false;
        }
      )

      // Handle getFirstFeature rejected state
      .addCase(getFirstFeature.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

  },
});

// Export actions for use in components
export const {
setLoading
} = firstFeatureSlice.actions;

// Export reducer for store
export default firstFeatureSlice.reducer;
